import objectAssign from 'object-assign';
import initialState from '../initialState';
import {actionTypes} from "../../actions/errorActions";

export default function errorReducer(state = initialState.error, action) {

  switch (action.type) {

    case actionTypes.THROW_ERROR:
      return objectAssign({}, state, {
        nonComponentError: action.data
      });

    default:
      return state;
  }
}
